module.exports = __webpack_public_path__ + "img/editor_preview-star_map.e0a77f9.webp";